import { Navigate, Route, Routes } from 'react-router-dom';
import type { Persistor } from 'redux-persist';
import NotFound from '@rsos/components/capstone/ErrorBoundary/NotFound';
import { AppInnerWrapper } from '@rsos/components/capstone/Layout/AdminLayout/AdminLayout.styles';
import { Box, Text } from '@rsos/components/capstone/base';
import { MANAGE_COMMUNICATION } from '@rsos/constants/permissions';
import { useFlag } from '@rsos/flags';
import useHasPermission from '@rsos/hooks/useHasPermission';
import CommunicationContainer from '../components/CommunicationContainer';
import { CommunicationDescription } from '../components/CommunicationDescription';
import MessagingAdmin from '../components/MessagingAdmin';
import PreConfiguredMessages from '../components/PreConfiguredMessages';

const TextFrom911 = ({ persistor }: { persistor: Persistor }) => (
  <Box>
    <Box>
      <Text size="header" fontWeight="bold" color="primaryText">
        Text-from-911
      </Text>
      <Text mt={24} size="xlarge" fontWeight="bold" color="primaryText">
        Conversation History
      </Text>
    </Box>
    <Box mt={2}>
      <CommunicationDescription persistor={persistor} />
      <CommunicationContainer />
      <PreConfiguredMessages />
    </Box>
  </Box>
);

const Main = ({ persistor }: { persistor: Persistor }) => {
  const hasManageCommunicationPermission =
    useHasPermission(MANAGE_COMMUNICATION);
  const isMessagingAdminEnabled = useFlag('enable_messaging_admin');

  if (!hasManageCommunicationPermission?.hasPermission) {
    return null;
  }

  return (
    <Routes>
      <Route
        path="text-from-911"
        element={
          isMessagingAdminEnabled ? (
            <Navigate to="/admin/messaging" replace />
          ) : (
            <AppInnerWrapper>
              <TextFrom911 persistor={persistor} />
            </AppInnerWrapper>
          )
        }
      />
      {isMessagingAdminEnabled && (
        <Route path="messaging" element={<MessagingAdmin />} />
      )}
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

export default Main;
